import { render, staticRenderFns } from "./proposal-list-item.vue?vue&type=template&id=07b43262&scoped=true&"
import script from "./proposal-list-item.vue?vue&type=script&lang=js&"
export * from "./proposal-list-item.vue?vue&type=script&lang=js&"
import style0 from "./proposal-list-item.vue?vue&type=style&index=0&id=07b43262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b43262",
  null
  
)

export default component.exports